import { PoolLeagueApiClient } from '../base-client/pool-league-api-client';
import { Injectable } from '@angular/core';
import {
  KILLER_GET_SESSION_ID,
  KillerSessionId,
} from '@pool-league/shared-data-api';
import { catchError, map, Observable, of, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class KillerApiClient extends PoolLeagueApiClient {
  readonly #getSessionId = this.buildRequest(KILLER_GET_SESSION_ID);

  getSessionId(): Observable<string | undefined> {
    return this.#getSessionId.get<KillerSessionId>().pipe(
      map(({ sessionId }) => sessionId),
      catchError((error) =>
        error instanceof HttpErrorResponse && error.status === 404
          ? of(undefined)
          : throwError(() => error),
      ),
    );
  }
}
